import React from 'react';

import { i18n } from 'app/i18n';
import { Typography } from 'app/components/domain/typography';
import { OrderSummary } from 'app/page/orders/model/order-summary';

import styles from './total-prices.module.scss';

interface OwnProps {
    orderSummary: OrderSummary;
}

type Props = OwnProps;

class TotalPrices extends React.Component<Props> {
    public render(): React.ReactNode {
        const { orderSummary } = this.props;

        return (
            <div className={styles.totalPricesContainer}>
                <div className={styles.priceContainer}>
                    <Typography className={styles.priceText} variant="body1" component="strong">
                        {i18n.summary.totalPrice.monthlyPrice.label}
                    </Typography>
                    <Typography className={styles.price} variant="body1" component="strong">
                        {orderSummary.monthlyPrice}
                    </Typography>
                </div>
                <div className={styles.priceContainer}>
                    <Typography className={styles.priceText} variant="body1" component="p">
                        {i18n.summary.totalPrice.initialPrice.label}
                    </Typography>
                    <Typography className={styles.price} variant="body1" component="p">
                        {orderSummary.initialPrice}
                    </Typography>
                </div>
            </div>
        );
    }
}

export { TotalPrices };
